import { useState, useEffect } from 'react';
import { getCardsT1 } from 'services/T1Pagos';
import { useValUserT1 } from 'hooks/useValUserT1';
import { decodeStorage } from 'functions/storageBase64'
import { useToken } from 'hooks/useToken'
import { useInterceptor } from './token/useInterceptor';

export function useCardsListT1() {

    const { tokenT1Card, errorT } = useValUserT1();
    const [cardsResponse, setCardsResponse] = useState();
    const [cardsArray, setCardsArray] = useState();
    const [udArray, setUdArray] = useState(false);
    const [loading, setLoading] = useState(true);

    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState(null);
    const [showModalErr, setShowModalErr] = useState(false);

    const {
        setActionOk,
        setServiceRT,
        actionOK,
        serviceRT
    } = useInterceptor()

    /*  --------------------------- Inicio --------------------------------------  */
        // const timeToken  = useToken({firstActive: false, name: "use get T1", timeRef: 1000 })
        // const [actionOK, setActionOk] = useState(false)
        //     useEffect(() => {
        //         setTimeout(function(){
        //             if(tokenT1Card ){
        //                 setActionOk(true)
        //             }else if(udArray){
        //                 setActionOk(true)
        //             }
        //         },900)
        //     }, [tokenT1Card, udArray])
       /*  --------------------------- Inicio Peticiones --------------------------------------  */
            //  Ajusta Los tiempos y refresca token
            // const [serviceRT, setServiceRT] = useState(false)
            // useEffect(()=>{
            //     if(actionOK){
            //         let  actTimeLS = Date.now()
            //         let  atExpLS = decodeStorage('access_token_exp') * 1000
        
            //         // console.log('------------------------------')
            //         // // console.log('actTimeLS m : ', ( new Date( Date.now() + 180000) ) )
            //         // console.log('actTimeLS   : ', new Date() )
            //         // console.log('atExp   : ', new Date (atExpLS) )
            //         // console.log('time ok : ', actTimeLS <= atExpLS)
            //         // console.log('actionOK: ', actionOK)
            //         // console.log('------------------------------')
                    
            //         if(actTimeLS <= atExpLS || Date.now() <= (decodeStorage('access_token_exp') * 1000) ){
            //             setServiceRT(true)
            //         }
            //         else{
            //             timeToken.forceToken(true)
            //         }
            //     }
            // },[timeToken.newToken, actionOK])
        /*  --------------------------- Fin --------------------------------------  */

    useEffect(() => {
        setActionOk("useGetT1")
        // console.log('profileData: ', decodeStorage('profileData'))
    }, [])


    const [koToken, setOkToken] = useState(false)
    useEffect(() => {
        // console.log('serviceRT: ', serviceRT)
        if (serviceRT) {
            if(actionOK === 'useGetT1'){
                setOkToken(true)
                setServiceRT(false)
                setActionOk(false)
            }
        }
    }, [serviceRT])


    useEffect(() => {
        if(koToken){
            // console.log('asdasdas: ', tokenT1Card)
            if (tokenT1Card) {
                window.ineum('meta', 'UUID_T1', tokenT1Card);
                getCardsT1(tokenT1Card)
                .then(setCardsResponse)
                setOkToken(false)
            }
        }
    }, [tokenT1Card, koToken])


    useEffect(() => {
        // console.log('errorT: ',errorT)
        if (errorT) {
            setErrorCode(errorT);
            setLoading(false);
        }
    }, [errorT])

    useEffect(() => {
        if (cardsResponse) {
            // console.log('cardsResponse: ', cardsResponse)

            if (cardsResponse?.statusCode === 200 || cardsResponse?.statusCode === 201) {
                if (cardsResponse?.data) {
                    if (cardsResponse?.data.data) {
                        setCardsArray(cardsResponse?.data.data);
                        setLoading(false);
                    }
                }
            }
            else if (cardsResponse?.statusCode === 401) {

                let dataError = JSON.parse(cardsResponse?.data);
                setLoading(false);

                if (dataError) {
                    setShowModalErr(true);
                    setSectionActive("choiseCards");
                    setErrorCode({ codMen: dataError?.metadata?.http_status });
                    setMessageResponse(dataError?.data?.error?.error);
                }
            }
            else if (cardsResponse?.statusCode > 401 && cardsResponse?.statusCode < 500) {

                setErrorCode(cardsResponse?.statusCode);
                let dataError = JSON.parse(cardsResponse?.data);
                setLoading(false)

                if (dataError) {
                    setShowModalErr(true);
                    setSectionActive("choiseCards");
                    setErrorCode({ codMen: dataError?.metadata?.http_status });
                    setMessageResponse(dataError?.data?.error?.error);
                }
            }
            else if (cardsResponse?.statusCode >= 500) {
                setLoading(false);
                setErrorCode(500);
            }
        }
    }, [cardsResponse])


    const updateArrayCards = (val) => {
        setUdArray(val);
        // console.log('adasdas: ', val)
    }

    return {
        cardsArray,
        updateArrayCards,
        loading,
        setLoading,
        errorCode,
        showModalErr,
        setShowModalErr,
        sectionActive,
        messageResponse
    }
}

export function useCardAddT1() {

    const [formDataCard, setFormDataCard] = useState();
    const [cardData, setCardData] = useState();

    useEffect(() => {
        if (formDataCard) {
            console.log('formDataCard', formDataCard);
            setCardData(formDataCard);
        }
    }, [formDataCard])

    const addCardData = (value) => {
        setFormDataCard(value);
    }

    return {
        cardData,
        addCardData
    }
}